/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

import type { ItemQohErrorMessage } from '../types';
import type { FulfillmentGroup } from '@/types/reduxStore/skuDetails';

export function createItemQoHErrorMessage(
  fulfillmentGroups: FulfillmentGroup[],
  quantity: number,
  labelAnd: string,
  labelMessage: string
): ItemQohErrorMessage {
  let itemQohErrorMessage: ItemQohErrorMessage = {
    errorMessage: '',
    optionsWithError: [],
  };

  if (
    Array.isArray(fulfillmentGroups) &&
    fulfillmentGroups.length &&
    fulfillmentGroups[0].groupFulfillmentOptions
  ) {
    const activeGroup = fulfillmentGroups.find((group) => group.selected);
    const optionsWithError: number[] = [];
    const fulfillmentTypesUnavailable = activeGroup?.groupFulfillmentOptions
      .map((option) => {
        if (option.availableQty >= 0 && option.available && option.availableQty < quantity) {
          optionsWithError.push(option.fulfillmentTypeId);
          return option.fulfillmentTypeLabel;
        }
      })
      .filter((e) => !!e);

    if (!fulfillmentTypesUnavailable || fulfillmentTypesUnavailable.length === 0) {
      return itemQohErrorMessage;
    }

    const mergedTypeLabels =
      fulfillmentTypesUnavailable.length > 1
        ? fulfillmentTypesUnavailable.join(` ${labelAnd} `)
        : fulfillmentTypesUnavailable[0];
    const errorMessage = mergedTypeLabels && `${mergedTypeLabels} ${labelMessage}`;
    itemQohErrorMessage = errorMessage
      ? {
          errorMessage,
          optionsWithError,
        }
      : itemQohErrorMessage;
  }

  return itemQohErrorMessage;
}
